import {
    Card,
    CardBody,
    Table
} from "reactstrap";

import { PageVisitDto } from "../types/analyticsTypes";

interface Props {
    pages: PageVisitDto[];
}

function TopPagesTable({
    pages
}: Props) {

    return (

        <Card className="shadow-sm border-0 rounded-4">

            <CardBody>

                <h4 className="mb-4">
                    Top Visited Pages
                </h4>

                <Table
                    hover
                    responsive
                >

                    <thead>

                        <tr>

                            <th>#</th>

                            <th>Page</th>

                            <th>Visits</th>

                        </tr>

                    </thead>

                    <tbody>

                        {pages.map((page, index) => (

                            <tr key={page.pageUrl}>

                                <td>{index + 1}</td>

                                <td>{page.pageUrl}</td>

                                <td>{page.visits}</td>

                            </tr>

                        ))}

                    </tbody>

                </Table>

            </CardBody>

        </Card>

    );

}

export default TopPagesTable;